/**
 * 外教口语课数据
 * id: 唯一主键
 * posterSrc: 课程列表卡片图片地址
 * detail: 每一段就是一张图片，第1张图片为第1段，依次类推
 */
const LESSONS_IDX1_DATA = [
  {
    id: 'a5fc3b8983215149e1ad7a7aa206855d',
    title: '成人英语口语辅导',
    type: '外语口语',
    posterSrc: 'https://web-data.zmlearn.com/image/3QQ77UqqTtesRoPAhpWgJx/%E6%88%90%E4%BA%BA%E8%8B%B1%E8%AF%AD%E5%8F%A3%E8%AF%AD%E8%BE%85%E5%AF%BC%401.5x.png',
    detail: [
      'https://web-data.zmlearn.com/image/8N5icCgy8x4vG22ioNJLyf/%E6%88%90%E4%BA%BA%E8%8B%B1%E8%AF%AD%E5%8F%A3%E8%AF%AD%E8%BE%85%E5%AF%BC%E8%AF%A6%E6%83%851%401.5x.png',
      'https://web-data.zmlearn.com/image/zVJmuXGyapVHZETJStTUK/%E6%88%90%E4%BA%BA%E8%8B%B1%E8%AF%AD%E5%8F%A3%E8%AF%AD%E8%BE%85%E5%AF%BC%E8%AF%A6%E6%83%852%401.5x.png'
    ]
  },
  {
    id: '5a6275b46c73a732e1067bee53768ea7',
    title: '零基础在线英语培训',
    type: '外语口语',
    posterSrc: 'https://web-data.zmlearn.com/image/bCBvNLtDYijeaKUrj2KFcb/%E9%9B%B6%E5%9F%BA%E7%A1%80%E5%9C%A8%E7%BA%BF%E8%8B%B1%E8%AF%AD%E5%9F%B9%E8%AE%AD%401.5x.png',
    detail: [
      'https://web-data.zmlearn.com/image/HQPnAJAj8PiEShRedQr4U/%E9%9B%B6%E5%9F%BA%E7%A1%80%E5%9C%A8%E7%BA%BF%E8%8B%B1%E8%AF%AD%E5%9F%B9%E8%AE%AD%E8%AF%A6%E6%83%851%401.5x.png',
      'https://web-data.zmlearn.com/image/jUQGKeypHudDSLkU6o4AKC/%E9%9B%B6%E5%9F%BA%E7%A1%80%E5%9C%A8%E7%BA%BF%E8%8B%B1%E8%AF%AD%E5%9F%B9%E8%AE%AD%E8%AF%A6%E6%83%852%401.5x.png'
    ]
  },
  {
    id: 'e14945fc4452fffa5225fd78ee205d22',
    title: '上海成人零基础英语学校',
    type: '外语口语',
    posterSrc: 'https://web-data.zmlearn.com/image/aTMkRyvMPwZ9r1swcVGYD5/%E4%B8%8A%E6%B5%B7%E6%88%90%E4%BA%BA%E9%9B%B6%E5%9F%BA%E7%A1%80%E8%8B%B1%E8%AF%AD%E5%AD%A6%E6%A0%A1%401.5x.png',
    detail: [
      'https://web-data.zmlearn.com/image/sY9N29McviQ3kSq2LbYkEj/%E4%B8%8A%E6%B5%B7%E6%88%90%E4%BA%BA%E9%9B%B6%E5%9F%BA%E7%A1%80%E8%8B%B1%E8%AF%AD%E5%AD%A6%E6%A0%A1%E8%AF%A6%E6%83%851%401.5x.png',
      'https://web-data.zmlearn.com/image/q74yfEygDC3LnhLB8f1ZXH/%E4%B8%8A%E6%B5%B7%E6%88%90%E4%BA%BA%E9%9B%B6%E5%9F%BA%E7%A1%80%E8%8B%B1%E8%AF%AD%E5%AD%A6%E6%A0%A1%E8%AF%A6%E6%83%852%401.5x.png'
    ]
  },
  {
    id: '7cffe255eed17bf214303b89bef49284',
    title: '上海成人英语补习班',
    type: '外语口语',
    posterSrc: 'https://web-data.zmlearn.com/image/mdrp5xW3xKYzfQsBhwLKvE/%E4%B8%8A%E6%B5%B7%E6%88%90%E4%BA%BA%E8%8B%B1%E8%AF%AD%E8%A1%A5%E4%B9%A0%E7%8F%AD%401.5x.png',
    detail: [
      'https://web-data.zmlearn.com/image/e5w2dqB4mhgcoFnhTDZJdJ/%E4%B8%8A%E6%B5%B7%E6%88%90%E4%BA%BA%E9%9B%B6%E5%9F%BA%E7%A1%80%E8%8B%B1%E8%AF%AD%E5%AD%A6%E6%A0%A1%E8%AF%A6%E6%83%853%401.5x.png',
      'https://web-data.zmlearn.com/image/q74yfEygDC3LnhLB8f1ZXH/%E4%B8%8A%E6%B5%B7%E6%88%90%E4%BA%BA%E9%9B%B6%E5%9F%BA%E7%A1%80%E8%8B%B1%E8%AF%AD%E5%AD%A6%E6%A0%A1%E8%AF%A6%E6%83%852%401.5x.png'
    ]
  },
  {
    id: '715baf66c9832d50fe1031f26e349ef6',
    title: '上海汉普森英语vip成人英语培训班',
    type: '外语口语',
    posterSrc: 'https://web-data.zmlearn.com/image/8pTfj4k6SuLAi4HR3EXZ25/%E4%B8%8A%E6%B5%B7%E6%B1%89%E6%99%AE%E6%A3%AE%E8%8B%B1%E8%AF%ADvip%E6%88%90%E4%BA%BA%E8%8B%B1%E8%AF%AD%E5%9F%B9%E8%AE%AD%E7%8F%AD%401.5x.png',
    detail: [
      'https://web-data.zmlearn.com/image/RtyFpvCF5p6V7v4sSKhSF/%E4%B8%8A%E6%B5%B7%E6%B1%89%E6%99%AE%E6%A3%AE%E8%8B%B1%E8%AF%ADvip%E6%88%90%E4%BA%BA%E8%8B%B1%E8%AF%AD%E5%9F%B9%E8%AE%AD%E7%8F%AD%E8%AF%A6%E6%83%851%401.5x.png',
      'https://web-data.zmlearn.com/image/odJhVyQajogDvhmMop27MP/%E4%B8%8A%E6%B5%B7%E6%B1%89%E6%99%AE%E6%A3%AE%E8%8B%B1%E8%AF%ADvip%E6%88%90%E4%BA%BA%E8%8B%B1%E8%AF%AD%E5%9F%B9%E8%AE%AD%E7%8F%AD%E8%AF%A6%E6%83%852%401.5x.png'
    ]
  },
  {
    id: 'a05dbfb2c08ede09281052334537a9db',
    title: '上海企业英语培训机构',
    type: '外语口语',
    posterSrc: 'https://web-data.zmlearn.com/image/9eSZCiXsduQ1uNCvuVGGp6/%E4%B8%8A%E6%B5%B7%E4%BC%81%E4%B8%9A%E8%8B%B1%E8%AF%AD%E5%9F%B9%E8%AE%AD%E6%9C%BA%E6%9E%84%401.5x.png',
    detail: [
      'https://web-data.zmlearn.com/image/6p4HQF1Px3kaqxqcoQgZV3/%E4%B8%8A%E6%B5%B7%E4%BC%81%E4%B8%9A%E8%8B%B1%E8%AF%AD%E5%9F%B9%E8%AE%AD%E6%9C%BA%E8%AF%A6%E6%83%851%401.5x.png',
      'https://web-data.zmlearn.com/image/pLZnc6wdVdV2vjD47eUmgk/%E7%BB%84%20124282%401.5x.png'
    ]
  },
  {
    id: '881c1b8328919ecae55c80f836b4b870',
    title: '上海英语口语一对一培训',
    type: '外语口语',
    posterSrc: 'https://web-data.zmlearn.com/image/vm5KKM2BfDC7hYNtmddkPs/%E4%B8%8A%E6%B5%B7%E8%8B%B1%E8%AF%AD%E5%8F%A3%E8%AF%AD%E4%B8%80%E5%AF%B9%E4%B8%80%E5%9F%B9%E8%AE%AD%401.5x.png',
    detail: [
      'https://web-data.zmlearn.com/image/tntXUKtWBsjMLjQrhiSFcn/%E4%B8%8A%E6%B5%B7%E8%8B%B1%E8%AF%AD%E5%8F%A3%E8%AF%AD%E4%B8%80%E5%AF%B9%E4%B8%80%E5%9F%B9%E8%AE%AD%E8%AF%A6%E6%83%851%401.5x.png',
      'https://web-data.zmlearn.com/image/9TKrTZdrxfgbX5cSD5n6Pg/%E4%B8%8A%E6%B5%B7%E8%8B%B1%E8%AF%AD%E5%8F%A3%E8%AF%AD%E4%B8%80%E5%AF%B9%E4%B8%80%E5%9F%B9%E8%AE%AD%E8%AF%A6%E6%83%852%401.5x.png'
    ]
  },
  {
    id: '6a3aa0753570f4f1eb9af769b0bb8451',
    title: '学术英语网课',
    type: '外语口语',
    posterSrc: 'https://web-data.zmlearn.com/image/puQ5gLerbaJY1xDXnWYKxG/%E5%AD%A6%E6%9C%AF%E8%8B%B1%E8%AF%AD%E7%BD%91%E8%AF%BE%401.5x.png',
    detail: [
      'https://web-data.zmlearn.com/image/aKeX5hE5cBSGzNhiQJuHkS/%E4%B8%8A%E6%B5%B7%E8%8B%B1%E8%AF%AD%E5%8F%A3%E8%AF%AD%E4%B8%80%E5%AF%B9%E4%B8%80%E5%9F%B9%E8%AE%AD%E8%AF%A6%E6%83%851%401.5x%20(1).png',
      'https://web-data.zmlearn.com/image/jMf7vxGnBkCUcULnv7q8Po/%E4%B8%8A%E6%B5%B7%E8%8B%B1%E8%AF%AD%E5%8F%A3%E8%AF%AD%E4%B8%80%E5%AF%B9%E4%B8%80%E5%9F%B9%E8%AE%AD%E8%AF%A6%E6%83%852%401.5x%20(1).png'
    ]
  }
]

/**
 * 对外口语课数据
 * id: 唯一主键
 * posterSrc: 课程列表卡片图片地址
 * detail: 每一段就是一张图片，第1张图片为第1段，依次类推
 */
const LESSONS_IDX2_DATA = [
  {
    id: '011ff89b78337ba11ef0bfc4d3f40841',
    title: '上海对外汉语教学培训班',
    type: '对外口语',
    posterSrc: 'https://web-data.zmlearn.com/image/rxgjC6ScdGiV43muRFT54G/%E4%B8%8A%E6%B5%B7%E5%AF%B9%E5%A4%96%E6%B1%89%E8%AF%AD%E6%95%99%E5%AD%A6%E5%9F%B9%E8%AE%AD%E7%8F%AD%401.5x.png',
    detail: [
      'https://web-data.zmlearn.com/image/gcbwEQSCKCb1cN3QUh28U9/%E7%BB%84%20124281%401.5x.png',
      'https://web-data.zmlearn.com/image/kDAFYhEps2TMjwCHkjmk3P/%E4%B8%8A%E6%B5%B7%E5%AF%B9%E5%A4%96%E6%B1%89%E8%AF%AD%E6%95%99%E5%AD%A6%E5%9F%B9%E8%AE%AD%E7%8F%AD%E8%AF%A6%E6%83%852%401.5x.png'
    ]
  },
  {
    id: '5a8e6ecd84402ae84adb58e1ca6d92da',
    title: '上海杨浦区上海话培训班',
    type: '对外口语',
    posterSrc: 'https://web-data.zmlearn.com/image/ddGpZT7LSNcKvUTtjDBCnw/%E4%B8%8A%E6%B5%B7%E6%9D%A8%E6%B5%A6%E5%8C%BA%E4%B8%8A%E6%B5%B7%E8%AF%9D%E5%9F%B9%E8%AE%AD%E7%8F%AD%401.5x.png',
    detail: [
      'https://web-data.zmlearn.com/image/eKTDvr6wnZhy42k46MYaQi/%E4%B8%8A%E6%B5%B7%E5%AF%B9%E5%A4%96%E6%B1%89%E8%AF%AD%E5%9F%B9%E8%AE%AD%E7%8F%AD%E5%AD%A6%E8%B4%B9%E8%AF%A6%E6%83%851%401.5x.png',
      'https://web-data.zmlearn.com/image/ekzW2nNxByFE6puZDsBNXF/%E4%B8%8A%E6%B5%B7%E5%AF%B9%E5%A4%96%E6%B1%89%E8%AF%AD%E5%9F%B9%E8%AE%AD%E7%8F%AD%E5%AD%A6%E8%B4%B9%E8%AF%A6%E6%83%852%401.5x.png'
    ]
  },
  {
    id: '188a7d1ebf23eba454e1ff15de18574e',
    title: '上海黄浦区上海话培训班',
    type: '对外口语',
    posterSrc: 'https://web-data.zmlearn.com/image/vgUw4sTnFTa5ZFYqudNqY1/%E4%B8%8A%E6%B5%B7%E9%BB%84%E6%B5%A6%E5%8C%BA%E4%B8%8A%E6%B5%B7%E8%AF%9D%E5%9F%B9%E8%AE%AD%E7%8F%AD%401.5x.png',
    detail: [
      'https://web-data.zmlearn.com/image/6rnqKxuXzYAVKkKYkP1x1n/%E4%B8%8A%E6%B5%B7%E9%BB%84%E6%B5%A6%E5%8C%BA%E4%B8%8A%E6%B5%B7%E8%AF%9D%E5%9F%B9%E8%AE%AD%E7%8F%AD%E8%AF%A6%E6%83%851%401.5x.png',
      'https://web-data.zmlearn.com/image/2TVXFcZKnTvYdRe18XEbH7/%E4%B8%8A%E6%B5%B7%E6%B5%A6%E4%B8%9C%E6%96%B0%E5%8C%BA%E4%B8%8A%E6%B5%B7%E8%AF%9D%E5%9F%B9%E8%AE%AD%E7%8F%AD%E8%AF%A6%E6%83%852%401.5x.png'
    ]
  },
  {
    id: '4e839ce255cea1b17b488740e79f7257',
    title: '上海浦东新区上海话培训班',
    type: '对外口语',
    posterSrc: 'https://web-data.zmlearn.com/image/kzWwZSvasmfpm4nfVMcYZf/%E4%B8%8A%E6%B5%B7%E6%B5%A6%E4%B8%9C%E6%96%B0%E5%8C%BA%E4%B8%8A%E6%B5%B7%E8%AF%9D%E5%9F%B9%E8%AE%AD%E7%8F%AD%401.5x.png',
    detail: [
      'https://web-data.zmlearn.com/image/ehr4qnUeQYWrwqx3mMP9cN/%E4%B8%8A%E6%B5%B7%E6%B5%A6%E4%B8%9C%E6%96%B0%E5%8C%BA%E4%B8%8A%E6%B5%B7%E8%AF%9D%E5%9F%B9%E8%AE%AD%E7%8F%AD%E8%AF%A6%E6%83%851%401.5x.png',
      'https://web-data.zmlearn.com/image/2TVXFcZKnTvYdRe18XEbH7/%E4%B8%8A%E6%B5%B7%E6%B5%A6%E4%B8%9C%E6%96%B0%E5%8C%BA%E4%B8%8A%E6%B5%B7%E8%AF%9D%E5%9F%B9%E8%AE%AD%E7%8F%AD%E8%AF%A6%E6%83%852%401.5x.png'
    ]
  },
  {
    id: '6b3a57b752060a1dcbb3ff0a1a476925',
    title: '上海杨浦区上海话培训班',
    type: '对外口语',
    posterSrc: 'https://web-data.zmlearn.com/image/ddGpZT7LSNcKvUTtjDBCnw/%E4%B8%8A%E6%B5%B7%E6%9D%A8%E6%B5%A6%E5%8C%BA%E4%B8%8A%E6%B5%B7%E8%AF%9D%E5%9F%B9%E8%AE%AD%E7%8F%AD%401.5x.png',
    detail: [
      'https://web-data.zmlearn.com/image/w5uVrXyHNMgc6h5iFcdoqj/%E4%B8%8A%E6%B5%B7%E6%9D%A8%E6%B5%A6%E5%8C%BA%E4%B8%8A%E6%B5%B7%E8%AF%9D%E5%9F%B9%E8%AE%AD%E7%8F%AD%E8%AF%A6%E6%83%851%401.5x.png',
      'https://web-data.zmlearn.com/image/2TVXFcZKnTvYdRe18XEbH7/%E4%B8%8A%E6%B5%B7%E6%B5%A6%E4%B8%9C%E6%96%B0%E5%8C%BA%E4%B8%8A%E6%B5%B7%E8%AF%9D%E5%9F%B9%E8%AE%AD%E7%8F%AD%E8%AF%A6%E6%83%852%401.5x.png'
    ]
  },
  {
    id: 'aef34c972d3d6c525cbdf979a6aa6a60',
    title: '上海长宁区上海话培训班',
    type: '对外口语',
    posterSrc: 'https://web-data.zmlearn.com/image/hYuPQ742bbRBAa27dt31qu/%E4%B8%8A%E6%B5%B7%E9%95%BF%E5%AE%81%E5%8C%BA%E4%B8%8A%E6%B5%B7%E8%AF%9D%E5%9F%B9%E8%AE%AD%E7%8F%AD%401.5x.png',
    detail: [
      'https://web-data.zmlearn.com/image/5DaMAhKpmAVb4nJYXGa5i2/%E4%B8%8A%E6%B5%B7%E9%95%BF%E5%AE%81%E5%8C%BA%E4%B8%8A%E6%B5%B7%E8%AF%9D%E5%9F%B9%E8%AE%AD%E7%8F%AD%E8%AF%A6%E6%83%851%401.5x.png',
      'https://web-data.zmlearn.com/image/2TVXFcZKnTvYdRe18XEbH7/%E4%B8%8A%E6%B5%B7%E6%B5%A6%E4%B8%9C%E6%96%B0%E5%8C%BA%E4%B8%8A%E6%B5%B7%E8%AF%9D%E5%9F%B9%E8%AE%AD%E7%8F%AD%E8%AF%A6%E6%83%852%401.5x.png'
    ]
  },
  {
    id: '42293cd48a064bf242ccd350135548b0',
    title: '上海专业对外汉语培训学校',
    type: '对外口语',
    posterSrc: 'https://web-data.zmlearn.com/image/r4CFNW266wPUC6m2tp2gg8/%E4%B8%8A%E6%B5%B7%E4%B8%93%E4%B8%9A%E5%AF%B9%E5%A4%96%E6%B1%89%E8%AF%AD%E5%9F%B9%E8%AE%AD%E5%AD%A6%E6%A0%A1%401.5x.png',
    detail: [
      'https://web-data.zmlearn.com/image/oZ1ZmbC37c3m3R6cXEq9QF/%E4%B8%8A%E6%B5%B7%E4%B8%93%E4%B8%9A%E5%AF%B9%E5%A4%96%E6%B1%89%E8%AF%AD%E5%9F%B9%E8%AE%AD%E5%AD%A6%E6%A0%A1%E8%AF%A6%E6%83%851%401.5x.png',
      'https://web-data.zmlearn.com/image/ekzW2nNxByFE6puZDsBNXF/%E4%B8%8A%E6%B5%B7%E5%AF%B9%E5%A4%96%E6%B1%89%E8%AF%AD%E5%9F%B9%E8%AE%AD%E7%8F%AD%E5%AD%A6%E8%B4%B9%E8%AF%A6%E6%83%852%401.5x.png'
    ]
  }
]
/**
 * 对外口语课数据
 * id: 唯一主键
 * posterSrc: 课程列表卡片图片地址
 * detail: 每一段就是一张图片，第1张图片为第1段，依次类推
 */
const LESSONS_IDX3_DATA = [
  {
    id: '011ff89b78337ba11ef0bfc4d3f40841',
    title: '上海成人思维导图',
    type: '逻辑思维',
    posterSrc: 'https://web-data.zmlearn.com/image/g6aYyGVbUS7VbjxdW6hxsi/%E4%B8%8A%E6%B5%B7%E6%88%90%E4%BA%BA%E6%80%9D%E7%BB%B4%E5%AF%BC%E5%9B%BE%401.5x.png',
    detail: [
      'https://web-data.zmlearn.com/image/35ELsDHhVLUyRK9JWVh851/%E4%B8%8A%E6%B5%B7%E6%88%90%E4%BA%BA%E6%80%9D%E7%BB%B4%E5%AF%BC%E5%9B%BE%E8%AF%A6%E6%83%851%401.5x.png',
      'https://web-data.zmlearn.com/image/uKbQw44NUgW8BYpSy74xAa/%E4%B8%8A%E6%B5%B7%E6%80%9D%E7%BB%B4%E5%AF%BC%E5%9B%BE%E5%9F%B9%E8%AE%AD%E8%AF%A6%E6%83%852%401.5x.png'
    ]
  },
  {
    id: '5a8e6ecd84402ae84adb58e1ca6d92da',
    title: '上海积木拼搭培训',
    type: '逻辑思维',
    posterSrc: 'https://web-data.zmlearn.com/image/FdUyjLU8woLrJDeZ5NahX/%E4%B8%8A%E6%B5%B7%E7%A7%AF%E6%9C%A8%E6%8B%BC%E6%90%AD%E5%9F%B9%E8%AE%AD%401.5x.png',
    detail: [
      'https://web-data.zmlearn.com/image/muNNsauuwMTMZowu6cPKf3/%E4%B8%8A%E6%B5%B7%E7%A7%AF%E6%9C%A8%E6%8B%BC%E6%90%AD%E5%9F%B9%E8%AE%AD%E8%AF%A6%E6%83%851%401.5x.png',
      'https://web-data.zmlearn.com/image/fU6kVr1oMmkieGY39bn6qR/%E4%B8%8A%E6%B5%B7%E7%A7%AF%E6%9C%A8%E6%8B%BC%E6%90%AD%E5%9F%B9%E8%AE%AD%E8%AF%A6%E6%83%852%401.5x.png'
    ]
  },
  {
    id: '188a7d1ebf23eba454e1ff15de18574e',
    title: '上海逻辑思维能力培训班',
    type: '逻辑思维',
    posterSrc: 'https://web-data.zmlearn.com/image/fHQBK64dn5F8vL3vP7Nc9Z/%E4%B8%8A%E6%B5%B7%E9%80%BB%E8%BE%91%E6%80%9D%E7%BB%B4%E8%83%BD%E5%8A%9B%E5%9F%B9%E8%AE%AD%E7%8F%AD%401.5x.png',
    detail: [
      'https://web-data.zmlearn.com/image/fPohmWnkWKBVEYXZC3cv1/%E4%B8%8A%E6%B5%B7%E9%80%BB%E8%BE%91%E6%80%9D%E7%BB%B4%E8%83%BD%E5%8A%9B%E5%9F%B9%E8%AE%AD%E7%8F%AD%E8%AF%A6%E6%83%851%401.5x.png',
      'https://web-data.zmlearn.com/image/8rqk9QwTeS9mGmjJXphaww/%E4%B8%8A%E6%B5%B7%E9%80%BB%E8%BE%91%E6%80%9D%E7%BB%B4%E8%83%BD%E5%8A%9B%E5%9F%B9%E8%AE%AD%E7%8F%AD%E8%AF%A6%E6%83%852%401.5x.png'
    ]
  },
  {
    id: '4e839ce255cea1b17b488740e79f7257',
    title: '上海思维导图课程',
    type: '逻辑思维',
    posterSrc: 'https://web-data.zmlearn.com/image/82HqcAKDQupg93unuNMqoT/%E4%B8%8A%E6%B5%B7%E6%80%9D%E7%BB%B4%E5%AF%BC%E5%9B%BE%E8%AF%BE%E7%A8%8B%401x.png',
    detail: [
      'https://web-data.zmlearn.com/image/AeV56vU2qUUNsEQ2RqA9s/%E4%B8%8A%E6%B5%B7%E6%80%9D%E7%BB%B4%E5%AF%BC%E5%9B%BE%E8%AF%BE%E7%A8%8B%E8%AF%A6%E6%83%851%401.5x.png',
      'https://web-data.zmlearn.com/image/v4QH22UwHhFoNkjyJKHWyp/%E4%B8%8A%E6%B5%B7%E6%80%9D%E7%BB%B4%E5%AF%BC%E5%9B%BE%E8%AF%BE%E7%A8%8B%E8%AF%A6%E6%83%852%401.5x.png'
    ]
  },
  {
    id: '6b3a57b752060a1dcbb3ff0a1a476925',
    title: '上海思维导图培训',
    type: '逻辑思维',
    posterSrc: 'https://web-data.zmlearn.com/image/5pBgyqLYhq2X2B1aofqqLt/%E4%B8%8A%E6%B5%B7%E6%80%9D%E7%BB%B4%E5%AF%BC%E5%9B%BE%E5%9F%B9%E8%AE%AD%401.5x.png',
    detail: [
      'https://web-data.zmlearn.com/image/c8yjs6zd6EkCycc1bWTqKr/%E4%B8%8A%E6%B5%B7%E6%80%9D%E7%BB%B4%E5%AF%BC%E5%9B%BE%E5%9F%B9%E8%AE%AD%E8%AF%A6%E6%83%851%401.5x.png',
      'https://web-data.zmlearn.com/image/4KiJ2atCR697ezUgGAnFya/%E4%B8%8A%E6%B5%B7%E6%88%90%E4%BA%BA%E6%80%9D%E7%BB%B4%E5%AF%BC%E5%9B%BE%E8%AF%A6%E6%83%852%401.5x.png'
    ]
  },
  {
    id: 'aef34c972d3d6c525cbdf979a6aa6a60',
    title: '上海思维导图培训(小班)',
    type: '逻辑思维',
    posterSrc: 'https://web-data.zmlearn.com/image/r6H1KnEhG5K9wS5ofxT9Xg/%E4%B8%8A%E6%B5%B7%E6%80%9D%E7%BB%B4%E5%AF%BC%E5%9B%BE%E5%9F%B9%E8%AE%AD%401.5x%20(1).png',
    detail: [
      'https://web-data.zmlearn.com/image/uNEdr37idadeXQeK2vCjL/%E4%B8%8A%E6%B5%B7%E6%80%9D%E7%BB%B4%E5%AF%BC%E5%9B%BE%E5%9F%B9%E8%AE%AD%EF%BC%88%E5%B0%8F%E7%8F%AD%EF%BC%89%E8%AF%A6%E6%83%851%401.5x.png',
      'https://web-data.zmlearn.com/image/s34ZhbiQv6XLR2MbhSrVcY/%E4%B8%8A%E6%B5%B7%E6%80%9D%E7%BB%B4%E5%AF%BC%E5%9B%BE%E5%9F%B9%E8%AE%AD%EF%BC%88%E5%B0%8F%E7%8F%AD%EF%BC%89%E8%AF%A6%E6%83%852%401.5x.png'
    ]
  }
]
/**
 * 逻辑思维课数据
 * id: 唯一主键
 * title: 标题
 * desc: 每一项就是一个段落，第1项为第1段，依次类推
 * time: 时间
 */
const LESSONS_DATA = [
  {
    id: '8c492b2a88ff928027cb41dfe83260c6',
    title: '美育素养纳入教师资格考试 中小学要组织全员艺术素质测评',
    carouselSrc: 'https://web-data.zmlearn.com/image/5Eb2DHbDJLAnPbroGacffL/%E5%A4%96%E6%95%99%E5%8F%A3%E8%AF%AD%401.5x.png',
    detail: [
      {
        type: 'p',
        val: '教育部发布通知，要求将美育素养有关内容纳入教师资格考试，学校将美育课程纳入师范类专业学生人文素养课程。中小学依据课程标准组织实施全员艺术素质测评。'
      },
      {
        type: 'p',
        val: '教育部明确，学校要大力推进艺术教育教学改革，严格按照各学段课程标准开齐开足上好艺术相关课程。义务教育阶段学校积极提供多样化、个性化的艺术选修课程和课后服务，帮助学生通过在校学习掌握1至2项艺术专项特长，满足学生兴趣特长发展需要；配发义务教育阶段艺术教材，遴选推荐一批优质美育课后读物。学校还要配齐配好美育教师，将美育纳入教育系统领导干部和教师培训计划，开展艺术学科教师素质与能力监测。'
      },
      {
        type: 'p',
        val: '中小学要依据课font-fa程标准组织实施全员艺术素质测评，鼓励拓展测评内容和方法，完善初、高中艺术科目学业水平考试，将美育评价纳入学生综合素质档案；高校落实本科学生修满公共艺术课程至少2个学分的基本要求，注重与专业人才培养相结合，强化审美素养和创新意识的评价。学校还要根据实际建设小型美术馆、博物馆、展览厅、音乐厅、剧场等美育实践活动场地。'
      },
      {
        type: 'p',
        val: '到2027年，美育课程教育教学质量将全面提升，常态化学生全员艺术展演展示机制基本建立，跨学科优质美育资源体系初步建成，面向师范类专业学生开设美育课程实现全覆盖，艺术学科骨干教师培训全面开展。'
      }
    ],
    time: '2024-05-18 15:50:00'
  },
  {
    id: '687b101cfca6f088708f66d86aa50175',
    title: '44项全国中小学生白名单赛事报名网址超全汇总！',
    carouselSrc: 'https://web-data.zmlearn.com/image/j5M1rDoKaHRQ7HroygWdor/%E4%BB%A3%E7%90%86%E6%8B%9B%E7%94%9F%401.5x.png',
    detail: [
      {
        type: 'p',
        val: '教育部44项白名单赛事介绍及官网报名地址，以及正在报名中的赛事，意向综合评价的考生重点关注，积极参加，欢迎收藏转发分享给更多考生家长！'
      },
      {
        type: 'p',
        val: '白名单赛事指的是教育部公布的《2022-2025学年面向中小学生的全国性竞赛活动名单竞赛活动》，比赛分为“自然科学素养类”、“人文综合素养类”、“艺术体育类”三个大类。'
      },
      {
        type: 'p',
        val: '2022-2025学年中小学竞赛白名单共有44项竞赛进入名单，其中自然科学素养类：23项，人文综合素养类：12项，艺术体育类：9项，详细名单如下：'
      },
      {
        type: 'img',
        val: 'https://web-data.zmlearn.com/image/kCgvTmbDDY3TCVZBXRwHF7/b9090d0b-f4bf-4285-9aac-f40552483c23.png'
      }
    ],
    time: '2024-05-15 12:30:00'
  },
  {
    id: '29393c7e549700811b42c27c34530162',
    title: '研学北京：探索历史文化与现代发展的完美融合',
    carouselSrc: 'https://web-data.zmlearn.com/image/c654znetsvXtk7EWK2ZmSk/%E9%80%BB%E8%BE%91%E6%80%9D%E7%BB%B4%401.5x.png',
    detail: [
      {
        type: 'img',
        val: 'https://web-data.zmlearn.com/image/os49WzvXUu2xv7NZYHuEGZ/Dingtalk_20240517102959.jpg'
      },
      {
        type: 'p',
        val: '北京市，作为中国的首都和文化中心，近日迎来了一批批国内外的游学团体。他们的目标一致：深入中国顶尖学府清华大学和北京大学，体验独具特色的研学之旅。这两所高校不仅以卓越的学术成就和悠久的教育传统闻名于世，更成为研学旅行的宝地，为无数求知者提供了丰富的学习资源和启发性的教育经验。'
      },
      {
        type: 'p',
        val: '清华大学和北京大学，这两所学府被誉为中国高等教育的双子星座，它们以开放的姿态迎接来自世界各地的学者和学生。在这里进行研学的学生们可以亲身感受到世界级大学的氛围，与优秀的师生进行交流，获得知识的灵感和创新的动力。在清华园里，古典与现代的建筑风格交相辉映，漫步其间，仿佛能够听到历史的回声与时代的脉搏。学生们不仅可以在工程、科学、艺术等领域的专家指导下进行实验和探讨，还能参与模拟联合国等社团活动，锻炼领导力和团队合作能力。'
      },
      {
        type: 'img',
        val: 'https://web-data.zmlearn.com/image/dGzz5ZyZ55JiKkyeAvfWwG/Dingtalk_20240517103033.jpg'
      },
      {
        type: 'p',
        val: '北京大学则以其人文精神著称，未名湖、博雅塔等标志性景观已成为研学的经典路线。在这里，学生们可以参加中文、历史、哲学等人文社科类课程的学习和研讨，深入了解中国的文化和社会发展。同时，北大还提供国际关系和政治学等课程，帮助学生构建全球化视野。除了学术课程的丰富性，清华和北大还提供了多种实践机会。学生们可以参与科研项目，与教授们一起探索前沿科学问题，或是参与社会服务活动，如支教、环保等，将所学知识应用到实际中去。'
      },
      {
        type: 'img',
        val: 'https://web-data.zmlearn.com/image/cA5Rah1KBzdMGTPNe9p882/Dingtalk_20240517103102.jpg'
      },
      {
        type: 'p',
        val: '此外，这两所大学还拥有丰富的文化资源，如博物馆、图书馆和各类讲座，为学生提供了广泛的自学和研究空间。在这些环境中，学生们能够接触到最新的学术成果和思想潮流，激发自己的思考和创造力。研学北京，尤其是在清华和北大这样的高等学府中，不仅是一次知识的积累过程，更是一次心灵和能力的成长之旅。学生们在这里不仅能够学习到专业知识，还能够培养独立思考、批判性分析的能力，为未来的学术研究或职业生涯打下坚实的基础。随着越来越多的学生选择在清华和北大进行研学，这里已经成为全球学子了解中国、启迪思维的重要平台。北京，这座古老的城市，正通过这两所高校的窗口，向世界展示其深厚的文化底蕴和现代教育的活力。'
      }
    ],
    time: '2024-05-10 22:00:00'
  },
  {
    id: '6b25d63c0ab941c9eb369b5cdea8981d',
    title: '带你走进清北励志营',
    carouselSrc: '',
    detail: [
      {
        type: 'img',
        val: 'https://web-data.zmlearn.com/image/nMfTGziWMhKPGD3ATCyGAL/Dingtalk_20240517103018.jpg'
      },
      {
        type: 'p',
        val: '作为南方学子，我始终憧憬着在清华和北大这两所中国顶尖学府深造。近日，我有幸参加了一次清北研学之旅，亲身感受了这两所名校的魅力。'
      },
      {
        type: 'img',
        val: 'https://web-data.zmlearn.com/image/8AqZvz9jdzAmXveRYWVFmc/Dingtalk_20240517104029.jpg'
      },
      {
        type: 'p',
        val: '首站是清华大学，其校园美景令人叹为观止。绿树掩映，花香四溢，仿佛走进了人间仙境。我们参观了水木清华、荷塘月色等名胜，并聆听了一场关于清华历史与学术的讲座，深刻体验了清华的卓越魅力。'
      },
      {
        type: 'img',
        val: 'https://web-data.zmlearn.com/image/sHm2WaC5xy4BAgjbqszUVf/Dingtalk_20240517104048.jpg'
      },
      {
        type: 'p',
        val: '第二天，我们来到北京大学，这里更注重人文气息。游览了博雅塔、未名湖等地标，并在燕京学堂听取了一场中国历史文化讲座，感受到了北大浓厚的文化与学术氛围。'
      },
      {
        type: 'p',
        val: '除了参观，我们还与两校的优秀学生交流，他们的学习经历和成就激励了我，坚定了我对学术的追求。'
      },
      {
        type: 'p',
        val: '这次研学之旅让我深刻理解了这些顶尖学府的吸引力：优美的环境、深厚的文化底蕴、一流的师资和先进的设施，培养出的优秀人才为全球文明发展做出了贡献。'
      },
      {
        type: 'p',
        val: '通过这次经历，我不仅深入了解了清北的校园文化和历史，还结识了志同道合的朋友，为自己的未来规划了清晰的目标：成为一名学者，为人类进步贡献力量。我将永远铭记这次研学之旅的经历，激发学习热情和创新精神。我相信，只要努力，就能实现梦想。最后，我要感谢这次研学之旅的组织者，为我们提供了这个宝贵的机会。我会珍惜这份友谊和经验，为自己人生旅程加油。在这个充满机遇和挑战的时代，让我们携手前行，用智慧和汗水书写属于我们的精彩篇章！'
      }
    ],
    time: '2024-05-08 21:00:00'
  },
  {
    id: '60d5c9ec6309fa7bd797497c1291dae1',
    title: '央视网:对校园霸凌动真格,学校不能当和事佬',
    carouselSrc: '',
    detail: [
      {
        type: 'p',
        val: '在校园霸凌事件中，学校的角色是特殊的，发挥着关键性的作用。面对校园霸凌行为，其态度、反应、措施具有直接又鲜明的导向意义。是“正激励”还是“负反馈”，很多时候取决于校方这个“裁判者”的“执法价值”“执法方式”。就像体育赛场上的执法，如果裁判员对犯规行为置之不理或高举轻放，势必造成运动员动作变形、比赛变味，失去公平公正竞技的意义。梳理近年来见诸媒体的校园霸凌案件，我们遗憾地发现，相当一部分学校在“裁判”时表现是不合格的，有时甚至是令人悲愤的，担不起“立德树人”的使命。'
      },
      {
        type: 'img',
        val: 'https://web-data.zmlearn.com/image/wUXaCQ5mZ2FSt15Jr5tsw2/Dingtalk_20240517105116.jpg'
      },
      {
        type: 'p',
        val: '最为公众和舆论诟病的一种现象是，不少学校习惯性地大事化小、小事化了，总是寄望于在学校“内部消化”。这背后有基于保护未成年人权益、维护所谓学校声誉等各种因素的考虑。如果霸凌者确实属于初犯、轻犯，在学校迅速处置过程中能真诚悔过，争得受害者及其家长的谅解，这样的做法倒也无可厚非。'
      },
      {
        type: 'p',
        val: '但事实上，众多的校园霸凌行为、事件乃至案件，学校循着强行“内部消化”思维是消化不了的。如果受害者已经遭受严重的人身、精神伤害和财产损失，学校还继续沿续一种表面的、形式化的“调解”与不痛不痒的处罚，无异于“变相助长”了霸凌者的无法无天的嚣张气焰和戾气，将来恐怕会酿成更大的事故。'
      },
      {
        type: 'p',
        val: '我们的教训还不够多吗？备受关注的大同大成双语学校霸凌案，受害者遭受霸凌长达一年半之久，最终导致令人震惊的“极端欺辱”恶行。因此，学校的管理者、教师当有法的意识和“不护犊子”的胸襟与担当，这不仅是对孩子的当下与未来负责，也是对学校自身负责。'
      },
      {
        type: 'p',
        val: '“家丑不可外扬”这样陈旧的观念该转变了，“霸凌不存在，就是孩子间打闹”这样的老思维该革新了。学校在实践中更要把之前欠在教学管理内容上的“功课”补上。一方面，学校应有完善的帮扶救济制度，一旦发生霸凌事件能快速反应，给予受害者充分的关怀、抚慰，针对不同事件采取系统性措施，帮助其尽快回归正常学习、生活状态。在这方面，学校发挥的作用不亚于家庭。另一方面，对霸凌者施以与之行为相匹配的惩罚惩戒，对有严重不良行为者，主动申请将其送入专门学校，进行矫治教育；对涉嫌犯罪的，要第一时间向公安机关报案，追究法律责任。在德与法之间，德是法的底线。学校要立德树人，以德育人。学校管得了，就要严管厚爱；学校管不了，那就该用法律维护学生的权益、维护学校的名誉。相对于事后的惩罚，事前的预防才是基础和根本。现实的痛点是，长期以来，过度的应试教育与薄弱的德育教育失衡，导致我们过于注重孩子的学业，而忽视了对孩子健康人格的培养与塑造，这也无形之中为校园霸凌埋下了隐患。我们不能将发生在校园的霸凌行为责任都推给学校，家庭、社会等各方均有责任。但改变这一现状，提升德育教育的力度和实效，学校的角色尤为关键，当有更实的作为，不能再流于形式、浮于表面。'
      },
      {
        type: 'p',
        val: '这些年，各地有不少可资借鉴的经验和值得提倡的做法。譬如，建立“法治副校长”机制，如能真正将其“普法者”“守卫者”的制度目标落到实处，无疑将在遏制校园霸凌中发挥重要作用。又如，专门开展法治辅导、培训，让学生、教师都能全面了解校园霸凌的危害，培养反霸凌的意识和能力。这不是对学校求全责备，而是其职责所在、分内之事。事实上，在减轻教师行政任务负担、鼓励课间十分钟让孩子撒个欢等现实问题上，舆论和公众一直呼吁要给予学校、教师更多的理解、支持和包容，创造相对宽松的环境。但一码归一码，在涉及校园霸凌问题上，学校作为第一责任人，有责任有义务也有条件展现更大的作为。在反校园霸凌中，学校这道关守住了，家庭、社会等方面的工作就有了坚实基础，往往能事半功倍，最终为孩子们创造一个安全、舒适的学习环境、成长空间。'
      }
    ],
    time: '2024-05-05 20:00:00'
  }
]

export {
  LESSONS_IDX1_DATA,
  LESSONS_IDX2_DATA,
  LESSONS_IDX3_DATA,
  LESSONS_DATA
}
